import React from 'react';
import { Menu, Popover } from '@econ/ui-elements';
import MenuLink from '../../shared/components/AuthorizedMenuLink';

export default function SettingsPopover() {
    return (
        <Popover width="175px">
            {({ closePopover }) => (
                <Menu>
                    <MenuLink href="/settings" onClick={closePopover}>
                        All settings
                    </MenuLink>
                    <MenuLink href="/user" onClick={closePopover}>
                        My settings
                    </MenuLink>
                    <MenuLink href="/logout" onClick={closePopover}>
                        Log off
                    </MenuLink>
                </Menu>
            )}
        </Popover>
    );
}
